import ReactDOM from 'react-dom';

export const createOffscreenContainer = () => {
    const container = document.createElement('div');
    Object.assign(container.style, {
        position: 'absolute',
        left: '-9999px'
    });
    document.body.appendChild(container);
    return container;
};

export const cleanupContainer = (container) => {
    ReactDOM.unmountComponentAtNode(container);
    document.body.removeChild(container);
};